import { useAtom, atom } from "jotai";

const navbarExpandedAtom = atom<boolean>(false);

export const useNavbarExpanded = () => {
  const [expanded, setExpanded] = useAtom(navbarExpandedAtom);
  return [expanded, setExpanded] as const;
};
